const envResolver = {
	COIN_LOGO_BASE_URL: process.env.REACT_APP_COIN_LOGO_BASE_URL ?? 'https://clycpublic.ams3.cdn.digitaloceanspaces.com/assets/',
	BOT_API_BASE_URL: process.env.REACT_APP_BOT_API_BASE_URL ?? 'https://api-bot.coinlocally.com',
	API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? 'https://api.coinlocally.com/',
	FOREX_TRADING_TERMINAL_URL: 'https://web.coinlocally.forex/terminal',
};

export { envResolver };
